module.exports = __webpack_public_path__ + "img/elementlengths_jasp.40827d5c.png";